import { get, post } from './../Config/config';

export const BulkMessage = {
    get: (data) => get(`/leads-list?phone_not_empty=1`, { params: data }),
    add: (data) => post('/label/create', data),




} 